var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"floating-btn",class:{ isHome: _vm.$route.name === 'home' }},[(!_vm.isTop)?_c('button',{staticClass:"btn top",attrs:{"data-content":_vm.$t('Components.FloatingButton.top')},on:{"click":function($event){return _vm.handleScrollToTop()}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }